import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { OFFER_ANCHOR } from '../utils/checkout';
export function StickyCTABar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('top');
    const footer = document.getElementById('site-footer');
    let pastHero = false;
    let footerVisible = false;
    const update = () => setVisible(pastHero && !footerVisible);
    const heroObserver = new IntersectionObserver(([entry]) => {
      pastHero = !entry.isIntersecting;
      update();
    }, {
      threshold: 0
    });
    const footerObserver = new IntersectionObserver(([entry]) => {
      footerVisible = entry.isIntersecting;
      update();
    }, {
      threshold: 0
    });
    if (hero) heroObserver.observe(hero);
    if (footer) footerObserver.observe(footer);
    return () => {
      heroObserver.disconnect();
      footerObserver.disconnect();
    };
  }, []);
  return <AnimatePresence data-id="element-237" data-mp="huko5rill24f">
      {visible && <motion.div initial={{
      y: 72,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 72,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 flex h-16 items-center justify-between gap-3 bg-brand-primary px-4 shadow-[0_-6px_18px_rgba(8,45,69,0.22)] md:hidden" data-id="element-238" data-mp="lyschnl58g24">
          <p className="flex items-baseline gap-2" data-id="element-239" data-mp="2zy0gmd2dtpn">
            <span className="font-display text-2xl font-extrabold leading-none text-white" data-id="element-240" data-mp="30pmb5gv0d2q">19 €</span>
            <span className="text-[11px] text-white/55 line-through" data-id="element-241" data-mp="3lf8kbbz6d6zi">225 €</span>
          </p>
          <a href={OFFER_ANCHOR} className="inline-flex min-h-[44px] items-center gap-1.5 rounded-full bg-brand-accent px-4 text-[11px] font-extrabold tracking-wide text-white transition-colors duration-150 ease-out hover:bg-[#e85a26] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-242" data-mp="3qcqlgg6yahwy">
            OTTIENI ORA
            <ArrowRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-243" data-mp="2shy16lxfpm7b" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}